// extracted by mini-css-extract-plugin
export default {"confirmModal":"Confirm_confirmModal__2FbNe","button":"Confirm_button__2vYoV"};